var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mall-player",class:_vm.theme},[(_vm.theme === 'video')?_c('video',{ref:"player",attrs:{"src":_vm._f("replaceUrlProtocol")(_vm.source),"playsinline":""}}):_c('audio',{ref:"player",attrs:{"src":_vm._f("replaceUrlProtocol")(_vm.source)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }